@sc-blue:#444DA1;
@sc-green:#6DBE45;
@sc-orange:#F47920;
@sc-black:#292C30;
@sc-gray:#61606D;

@base-unit:4px;
@margin:(2*@base-unit);

@width-sm:576px;
@width-md:768px;
@width-lg:992px;
@width-xl:1200px;
